export enum ECookies {
  TOKEN = 'ADMIN_TOKEN',
  REFRESH_TOKEN = 'ADMIN_REFRESH_TOKEN',
  TOKEN_TYPE = 'ADMIN_TOKEN_TYPE',
  TOKEN_EXPIRES_IN = 'ADMIN_TOKEN_EXPIRES_IN',
}

export const COOKIE_PATH = '/' as const;
